// extracted by mini-css-extract-plugin
export default {"sidebar":"RightSidebar_sidebar__C-jm1"};